<template>
  <div ref="cardchart" class="chart-card">
    <div class="card-header">
      <div v-if="!isMobile" class="card-title">{{ title }}</div>
      <div v-if="isMobile" class="card-title">
        <span>{{ title }}</span>
        <div class="button-download" @click="() => exportPBD(title)" />
      </div>
      <div class="card-buttons-wrapper">
        <TypeFilter v-if="typeFilter && typeFilter !== 'country'" :type="typeFilter" />
        <div v-if="searchable">
          <PBDSearch :type="typeFilter" @search-pressed="v => searchFunc(v, typeFilter)" />
        </div>
        <div v-if="!isMobile" class="button-download" @click="() => exportPBD(title)" />
      </div>
    </div>
    <div class="card-body">
      <template v-if="itemsViewed && chartId === 'item-con' && itemsViewed.count !== 0">
        <RankListChart :data="itemsViewed" :type="typeFilter" :items-for-page="itemsForPage" />
      </template>
      <template v-else-if="itemsDownload && chartId === 'item-download' && itemsDownload.count !== 0">
        <RankListChart :data="itemsDownload" :type="typeFilter" :items-for-page="itemsForPage" />
      </template>
      <template v-else-if="wordsSearched && chartId === 'words-search' && wordsSearched.count !== 0">
        <RankListChart :data="wordsSearched" :type="typeFilter" :items-for-page="itemsForPage"/>
      </template>
      <template v-else-if="countryUsage && chartId === 'country-use' && countryUsage.count !== 0">
        <RankListChart :data="countryUsage" :type="typeFilter" :items-for-page="itemsForPage" :hasLink="false" />
      </template>
      <div
        v-else-if="parsedDataByType && chartId === 'evolutiveByType' && evolutiveByTypeChart.count !== 0"
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDataByType.evolutive"
          chart-type="line-chart"
          :chart-config="evolutiveConfig"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="
          parsedDataByType && chartId === 'distributionByType' && evolutiveByTypeChart.count !== 0
        "
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDataByType.distribution"
          chart-type="bar-chart"
          :chart-config="distributionConfig"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="
          parsedDataByThesaurus &&
            chartId === 'evolutiveByThesaurus' &&
            evolutiveByThesaurusChart.count !== 0
        "
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDataByThesaurus.evolutive"
          chart-type="line-chart"
          :chart-config="evolutiveConfig"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="
          parsedDataByThesaurus &&
            chartId === 'distributionByThesaurus' &&
            evolutiveByThesaurusChart.count !== 0
        "
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDataByThesaurus.distribution"
          chart-type="bar-chart"
          :chart-config="distributionConfig"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="parsedDataWebAccess && chartId === 'access' && webAccessChart.count !== 0"
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDataWebAccess"
          :chart-config="lineChartConfig"
          chart-type="line-chart"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="parsedDataWebRegisters && chartId === 'registers' && webRegisterChart.count !== 0"
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDataWebRegisters"
          :chart-config="lineChartConfig"
          chart-type="line-chart"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="parsedLanguageUse && chartId === 'lang-use' && languageUseChart.count !== 0"
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedLanguageUse"
          :chart-config="pieChartConfig"
          chart-type="pie-chart"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="parsedDeviceUse && chartId === 'device-use' && deviceUseChart.count !== 0"
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedDeviceUse"
          :chart-config="pieChartConfig"
          chart-type="pie-chart"
          :tooltip-function="tooltipFunction"
        />
      </div>
      <div
        v-else-if="parsedTimeUse && chartId === 'time-use' && heatMapChart.count !== 0"
        class="chart-wrap"
      >
        <StatsSDVChart
          ref="chart"
          :data="parsedTimeUse"
          :chart-config="heatMapConfig"
          chart-type="heat-map"
        />
      </div>
      <div v-else-if="(chartId === 'item-con' && !itemsViewed) || (chartId === 'item-download' && !itemsDownload) || (chartId === 'words-search' && !wordsSearched) || (chartId === 'country-use' && !countryUsage) || (chartId === 'evolutiveByType' && !parsedDataByType) || (chartId === 'distributionByType' && !parsedDataByType) || (chartId === 'evolutiveByThesaurus' && !parsedDataByThesaurus) || (chartId === 'distributionByThesaurus' && !parsedDataByThesaurus) || (chartId === 'access' && !parsedDataWebAccess) || (chartId === 'registers' && !parsedDataWebRegisters) || (chartId === 'lang-use' && !parsedLanguageUse) || (chartId === 'device-use' && !parsedDeviceUse) || (chartId === 'time-use' && !parsedTimeUse)" class="loader-wrap">
        <Loader :text="$t('loading')" size="s" />
      </div>
      <div v-else class="no-data">{{ $t('no_data_for_these_filters') }}</div>
    </div>
    <div v-if="paginate" class="paginate-wrapper">
      <PBDPagination
        :data-search="itemsCount"
        :items-for-page="itemsForPage"
        :type="typeFilter"
        @toggle-data-loading="() => {}"
      />
    </div>
  </div>
</template>
  
<script>
import dayjs from 'dayjs'
import PBDSearch from './PBDSearch.vue'
import Loader from '../Loader.vue'
import RankListChart from './RankListChart.vue'
import PBDPagination from './PBDPagination.vue'
import TypeFilter from './TypeFilter.vue'
import { t } from '../../i18n'
//import SDVChart from '../charts/SDVChart.vue'
import StatsSDVChart from '../charts/StatsSDVChart.vue'
import { exportPBDStats } from '@/utils/pbdExportUtils.js'
import { statsSdvTooltipFunction } from '@/utils/chart'
import { bcnColors } from '@/utils/colorUtils.js'
import {
  getItemsViewed,
  getItemsDownloaded,
  getSearchedWords,
  getCountryUsage,
  getEvolutiveByType,
  getEvolutiveByThesaurus,
  getWebAccessChart,
  getWebRegistersChart,
  getLangUseChart,
  getDeviceUseChart,
  getHeatMapChart,
} from '../../services/pbd-api'
export default {
  components: { PBDSearch, Loader, TypeFilter, PBDPagination, RankListChart, /*SDVChart,*/ StatsSDVChart },
  props: {
    title: {
      type: String,
    },
    searchable: {
      type: Boolean,
    },
    typeFilter: {
      type: String,
    },
    paginate: {
      type: Boolean,
    },
    chartId: {
      type: String,
    },
  },
  data() {
    return {
      itemsForPage: 10,
      heatMapConfig: {
        sizeAttr: {
          value: null,
        },
        title: {
          value: '',
        },
        subTitle: {
          value: '',
        },
        sourceCredits: {
          value: '',
        },
        LegendBehavior: {
          showLegend: {
            value: true,
          },
        },
        showLabels: {
          value: false,
        },
        ItemsHelper: {
          colorScale: 'sequential2',
          colorDict: {
            value: {
              start: {
                color: '#E5F0FC',
              },
              end: {
                color: '#15537E',
              },
            },
          },
        },
      },
      pieChartConfig: {
        title: {
          value: '',
        },
        subTitle: {
          value: '',
        },
        sourceCredits: {
          value: '',
        },
        LegendBehavior: {
          showLegend: {
            value: true,
          },
        },
        showLabels: {
          value: false,
        },
        lite: {
          value: true,
        },
      },
      lineChartConfig: {
        LegendBehavior: {
          showLegend: {
            value: false,
          },
        },
        curve: {
          value: 'sharp',
        },
        pointsSize: {
          value: 'hidden',
        },
        title: {
          value: '',
        },
        subTitle: {
          value: '',
        },
        sourceCredits: {
          value: '',
        },
        lite: {
          value: true,
        },
        AxisHelper: {
          x: {
            valueFormat: {
              value: '[D]%d %b',
            },
            unit: {
              value: '',
            },
          },
        },
      },
    }
  },
  computed: {
    distributionConfig() {
      let arrayColors = bcnColors
      let newObjs = {}
      if (this.evolutiveByThesaurusChart) {
        let sortable = []
        let last = this.evolutiveByThesaurusChart.data?.values[(this.evolutiveByThesaurusChart.data.values.length - 1)]
        let items = this.evolutiveByThesaurusChart.data?.items
        Object.keys(last).forEach(el => {
          if (el !== 'date') {
            let it = items.find(ele => ele.id == el)
            sortable.push([it.label, last[el]])
          }
        })
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        })
        sortable.forEach((val, i) => {
          newObjs[val[0]] = {
            color: arrayColors[i],
            stroke: "solid",
            shape: null,
            icon: null
          }
        })
      }
      if (this.evolutiveByTypeChart) {
        let sortab = []
        let lastt = this.evolutiveByTypeChart.data?.values[(this.evolutiveByTypeChart.data?.values.length - 1)]
        Object.keys(lastt).forEach(x => {
          if (x !== 'date') {
            sortab.push([t(x), lastt[x]])
          }
        })
        sortab.sort(function(a, b) {
            return b[1] - a[1];
        })
        sortab.forEach((val, i) => {
          newObjs[val[0]] = {
            color: arrayColors[i],
            stroke: "solid",
            shape: null,
            icon: null
          }
        })
      }
      return {
        title: {
          value: '',
        },
        subTitle: {
          value: '',
        },
        sourceCredits: {
          value: '',
        },
        lite: {
          value: true,
        },
        AxisHelper: {
          x: {
            showTickValues: {
              value: true,
            },
            tickWrap: {
              value: 'ellipsis',
            },
          },
          y: {
            showTickValues: {
              value: true,
            },
          },
        },
        horizontal: {
          value: true,
        },
        dataSorting: {
          value: "desc",
        },
        ItemsHelper: {
          colorDict: {
            value: newObjs
          }
        },
      }
    },
    evolutiveConfig() {
      let arrayColors = bcnColors
      let newObjs = {}
      if (this.evolutiveByThesaurusChart) {
        let sortable = []
        let last = this.evolutiveByThesaurusChart.data?.values[(this.evolutiveByThesaurusChart.data.values.length - 1)]
        let items = this.evolutiveByThesaurusChart.data?.items
        Object.keys(last).forEach(el => {
          if (el !== 'date') {
            let it = items.find(ele => ele.id == el)
            sortable.push([it.label, last[el]])
          }
        })
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        })
        sortable.forEach((val, i) => {
          newObjs[val[0]] = {
            color: arrayColors[i],
            stroke: "solid",
            shape: null,
            icon: null
          }
        })
      }
      if (this.evolutiveByTypeChart) {
        let sortab = []
        let lastt = this.evolutiveByTypeChart.data?.values[(this.evolutiveByTypeChart.data?.values.length - 1)]
        Object.keys(lastt).forEach(x => {
          if (x !== 'date') {
            sortab.push([t(x), lastt[x]])
          }
        })
        sortab.sort(function(a, b) {
            return b[1] - a[1];
        })
        sortab.forEach((val, i) => {
          newObjs[val[0]] = {
            color: arrayColors[i],
            stroke: "solid",
            shape: null,
            icon: null
          }
        })
      }
      return {
        LegendBehavior: {
          showLegend: {
            value: true,
          },
        },
        curve: {
          value: 'sharp',
        },
        pointsSize: {
          value: 'hidden',
        },
        title: {
          value: '',
        },
        subTitle: {
          value: '',
        },
        sourceCredits: {
          value: '',
        },
        lite: {
          value: true,
        },
        AxisHelper: {
          x: {
            valueFormat: {
              value: '[D]%d %b',
            },
            unit: {
              value: '',
            },
          },
        },
        ItemsHelper: {
          colorDict: {
            value: newObjs
          }
        },
      }
    },
    itemsCount() {
      let count = { count: 0 }
      if (this.chartId === 'item-con' && this.itemsViewed) {
        count.count = this.itemsViewed.count
      } else if (this.chartId === 'item-download' && this.itemsDownload) {
        count.count = this.itemsDownload.count
      } else if (this.chartId === 'words-search' && this.wordsSearched) {
        count.count = this.wordsSearched.count
      } else if (this.chartId === 'country-use' && this.countryUsage) {
        count.count = this.countryUsage.count
      }
      return count
    },
    parsedDataByType() {
      let orderedTypes = ['STATISTICS', 'MICRODATA', 'DATASTORIES', 'SURVEY', 'DOCS', 'MAPS']
      let resp = null
      let parsedData = []
      if (this.evolutiveByTypeChart) {
        resp = {}
        let parsedHeader = ['date']
        orderedTypes.forEach(el => {
          parsedHeader.push(t(el))
        })
        parsedData.push(parsedHeader)
        let parsedBody = []
        this.evolutiveByTypeChart.data?.values?.forEach(el => {
          parsedBody.push(dayjs(el.date).format('x'))
          orderedTypes.forEach(elem => {
            parsedBody.push(el[elem] || '')
          })
          parsedData.push(parsedBody)
          parsedBody = []
        })
        resp.evolutive = parsedData

        let parsedDistData = []
        let inst = [...parsedData[parsedData.length - 1]]
        let dataHeaders = ['id', 'value']
        parsedDistData.push(dataHeaders)
        let dataDistBody = []
        orderedTypes.forEach((elem, i) => {
          dataDistBody.push(t(elem))
          dataDistBody.push(inst[i + 1] !== '' ? inst[i + 1] : 0)
          parsedDistData.push(dataDistBody)
          dataDistBody = []
        })
        resp.distribution = parsedDistData
        resp.distributionTypeDate = parseInt(inst[0])

        let vals = this.evolutiveByTypeChart.data?.values
        let minDate = vals[0]?.date || null
        let maxDate = vals[vals.length - 1]?.date || null
        // < 3 Meses => format DIA
        // > 3 Meses < 2 Anõs - format MESES
        // > 2 Años => format Año
        if (minDate && maxDate && dayjs(maxDate).subtract(2, 'year') > dayjs(minDate)) {
          this.changeAxisLabel(this.evolutiveConfig, 'any')
        } else if (minDate && maxDate && dayjs(maxDate).subtract(3, 'month') > dayjs(minDate)) {
          this.changeAxisLabel(this.evolutiveConfig, 'mes')
        } else {
          this.changeAxisLabel(this.evolutiveConfig, 'dia')
        }
      }
      return resp
    },
    parsedDataByThesaurus() {
      let resp = null
      let parsedData = []
      if (this.evolutiveByThesaurusChart) {
        resp = {}
        let parsedHeader = ['date']
        this.evolutiveByThesaurusChart.data?.items?.forEach(el => {
          parsedHeader.push(el.label)
        })
        parsedData.push(parsedHeader)
        let parsedBody = []
        this.evolutiveByThesaurusChart.data?.values?.forEach(el => {
          parsedBody.push(el.date ? dayjs(el.date).format('x') : null)
          this.evolutiveByThesaurusChart.data?.items?.forEach(elem => {
            parsedBody.push(el[elem.id] || '')
          })
          parsedData.push(parsedBody)
          parsedBody = []
        })
        resp.evolutive = parsedData

        let parsedDistData = []
        let inst = [...parsedData[parsedData.length - 1]]
        let idsList = [...parsedData[0]]
        let dataHeaders = ['id', 'value']
        parsedDistData.push(dataHeaders)
        let dataDistBody = []
        idsList.forEach((elem, i) => {
          if (i !== 0) {
            dataDistBody.push(elem)
            dataDistBody.push(inst[i] !== '' ? inst[i] : 0)
            parsedDistData.push(dataDistBody)
            dataDistBody = []
          }
        })
        resp.distribution = parsedDistData
        resp.distributionThesaurusDate = parseInt(inst[0])

        let vals = this.evolutiveByThesaurusChart.data?.values
        let minDate = vals[0]?.date || null
        let maxDate = vals[vals.length - 1]?.date || null
        // < 3 Meses => format DIA
        // > 3 Meses < 2 Anõs - format MESES
        // > 2 Años => format Año
        if (minDate && maxDate && dayjs(maxDate).subtract(2, 'year') > dayjs(minDate)) {
          this.changeAxisLabel(this.evolutiveConfig, 'any')
        } else if (minDate && maxDate && dayjs(maxDate).subtract(3, 'month') > dayjs(minDate)) {
          this.changeAxisLabel(this.evolutiveConfig, 'mes')
        } else {
          this.changeAxisLabel(this.evolutiveConfig, 'dia')
        }
      }
      return resp
    },
    parsedDataWebAccess() {
      let resp = null
      if (this.webAccessChart) {
        let parsedData = []
        let parsedHeader = ['date', t('interactions')]
        parsedData.push(parsedHeader)
        let parsedBody = []
        this.webAccessChart.data?.values?.forEach(el => {
          parsedBody.push(el.date ? dayjs(el.date).format('x') : null)
          parsedBody.push(el.count)
          parsedData.push(parsedBody)
          parsedBody = []
        })
        resp = parsedData

        let vals = this.webAccessChart.data?.values
        let minDate = vals[0]?.date || null
        let maxDate = vals[vals.length - 1]?.date || null
        // < 3 Meses => format DIA
        // > 3 Meses < 2 Anõs - format MESES
        // > 2 Años => format Año
        if (minDate && maxDate && dayjs(maxDate).subtract(2, 'year') > dayjs(minDate)) {
          this.changeAxisLabel(this.lineChartConfig, 'any')
        } else if (minDate && maxDate && dayjs(maxDate).subtract(3, 'month') > dayjs(minDate)) {
          this.changeAxisLabel(this.lineChartConfig, 'mes')
        } else {
          this.changeAxisLabel(this.lineChartConfig, 'dia')
        }
      }
      return resp
    },
    parsedDataWebRegisters() {
      let resp = null
      if (this.webRegisterChart) {
        let parsedData = []
        let parsedHeader = ['date', t('users')]
        parsedData.push(parsedHeader)
        let parsedBody = []
        this.webRegisterChart.data?.values?.forEach(el => {
          parsedBody.push(dayjs(el.date).format('x'))
          parsedBody.push(el.count)
          parsedData.push(parsedBody)
          parsedBody = []
        })
        resp = parsedData

        let vals = this.webRegisterChart.data?.values
        let minDate = vals[0]?.date || null
        let maxDate = vals[vals.length - 1]?.date || null
        // < 3 Meses => format DIA
        // > 3 Meses < 2 Anõs - format MESES
        // > 2 Años => format Año
        if (minDate && maxDate && dayjs(maxDate).subtract(2, 'year') > dayjs(minDate)) {
          this.changeAxisLabel(this.lineChartConfig, 'any')
        } else if (minDate && maxDate && dayjs(maxDate).subtract(3, 'month') > dayjs(minDate)) {
          this.changeAxisLabel(this.lineChartConfig, 'mes')
        } else {
          this.changeAxisLabel(this.lineChartConfig, 'dia')
        }
      }
      return resp
    },
    parsedLanguageUse() {
      let resp = null
      if (this.languageUseChart) {
        let parsedData = []
        let parsedHeader = ['id', 'value']
        parsedData.push(parsedHeader)
        let parsedBody = []
        this.languageUseChart.data?.values?.forEach(el => {
          parsedBody.push(el.label)
          parsedBody.push(el.count)
          parsedData.push(parsedBody)
          parsedBody = []
        })
        resp = parsedData
      }
      return resp
    },
    parsedDeviceUse() {
      let resp = null
      if (this.deviceUseChart) {
        let parsedData = []
        let parsedHeader = ['id', 'value']
        parsedData.push(parsedHeader)
        let parsedBody = []
        this.deviceUseChart.data?.values?.forEach(el => {
          parsedBody.push(el.label)
          parsedBody.push(el.count)
          parsedData.push(parsedBody)
          parsedBody = []
        })
        resp = parsedData
      }
      return resp
    },
    parsedTimeUse() {
      let resp = null
      if (this.heatMapChart) {
        // let parsedData = []
        // let parsedHeader = ['date', 'hour', 'color']

        // parsedData.push(parsedHeader)
        // let parsedBody = []
        // this.heatMapChart.data.values.forEach(el => {
        // 	parsedBody.push(dayjs(el.day).format('DD-MM-YYYY'))
        // 	parsedBody.push(el.hour)
        // 	parsedBody.push(el.count)
        // 	parsedData.push(parsedBody)
        // 	parsedBody = []
        // })
        let finalParse = []
        let finalHeads = ['date']
        let heads = []
        let arrayDates = []
        this.heatMapChart.data?.values?.forEach(el => {
          if (arrayDates.indexOf(t(el.day)) === -1) {
            arrayDates.push(t(el.day))
          }
          if (heads.indexOf(el.hour) === -1) {
            heads.push(el.hour)
          }
        })
        heads = heads.sort()
        finalHeads = finalHeads.concat(heads)
        //finalHeads.push(heads)
        finalParse.push(finalHeads)
        let bodyToParse = []
        arrayDates.forEach(ele => {
          bodyToParse.push(ele)
          for (let h = 1; h < finalHeads.length; h++) {
            bodyToParse.push(0)
          }
          finalParse.push(bodyToParse)
          bodyToParse = []
        })

        this.heatMapChart.data?.values?.forEach(el => {
          finalParse = this.completeTable(finalParse, el)
        })

        resp = finalParse
      }
      return resp
    },
  },
  asyncComputed: {
    itemsViewed() {
      return (
        this.chartId === 'item-con' &&
        getItemsViewed(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.query.typeFil ? this.$route.query.typeFil : 'all',
          this.$route.query.searchType ? this.$route.query.searchType : null,
          this.$route.query.itemsPage ? this.$route.query.itemsPage : 1,
          this.itemsForPage,
          this.$route.params.lang
        )
      )
    },
    itemsDownload() {
      return (
        this.chartId === 'item-download' &&
        getItemsDownloaded(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.query.downTypeFil ? this.$route.query.downTypeFil : 'all',
          this.$route.query.searchDownType ? this.$route.query.searchDownType : null,
          this.$route.query.downPage ? this.$route.query.downPage : 1,
          this.itemsForPage,
          this.$route.params.lang
        )
      )
    },
    wordsSearched() {
      return (
        this.chartId === 'words-search' &&
        getSearchedWords(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.query.langFil ? this.$route.query.langFil : 'ca',
          this.$route.query.searchLang ? this.$route.query.searchLang : null,
          this.$route.query.langPage ? this.$route.query.langPage : 1,
          this.itemsForPage
          //this.$route.params.lang,
        )
      )
    },
    countryUsage() {
      return (
        this.chartId === 'country-use' &&
        getCountryUsage(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.params.lang,
          this.$route.query.countryPage ? this.$route.query.countryPage : 1,
          this.itemsForPage
        )
      )
    },
    webAccessChart() {
      return (
        this.chartId === 'access' &&
        getWebAccessChart(this.$route.query.update ? this.$route.query.update : 'all')
      )
    },
    webRegisterChart() {
      return (
        this.chartId === 'registers' &&
        getWebRegistersChart(this.$route.query.update ? this.$route.query.update : 'all')
      )
    },
    evolutiveByTypeChart() {
      return (
        (this.chartId === 'evolutiveByType' || this.chartId === 'distributionByType') &&
        getEvolutiveByType(this.$route.query.update ? this.$route.query.update : 'all')
      )
    },
    evolutiveByThesaurusChart() {
      return (
        (this.chartId === 'evolutiveByThesaurus' || this.chartId === 'distributionByThesaurus') &&
        getEvolutiveByThesaurus(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.params.lang
        )
      )
    },
    languageUseChart() {
      return (
        this.chartId === 'lang-use' &&
        getLangUseChart(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.params.lang
        )
      )
    },
    deviceUseChart() {
      return (
        this.chartId === 'device-use' &&
        getDeviceUseChart(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.params.lang
        )
      )
    },
    heatMapChart() {
      return (
        this.chartId === 'time-use' &&
        getHeatMapChart(this.$route.query.update ? this.$route.query.update : 'all')
      )
    },
  },
  methods: {
    completeTable(table, element) {
      let hour = element.hour
      let day = t(element.day)
      let currTable = [...table]
      let x = table[0].findIndex(el => {
        return el === hour
      })
      let y = table.findIndex(el => {
        return el[0] === day
      })
      currTable[y][x] = element.count
      return currTable
    },
    changeAxisLabel(config, type) {
      if (type === 'mes') {
        config.AxisHelper.x.valueFormat.value = '[D]%b %y'
      } else if (type === 'any') {
        config.AxisHelper.x.valueFormat.value = '[D]%Y'
      } else if (type === 'dia') {
        config.AxisHelper.x.valueFormat.value = '[D]%d %b'
      }
    },
    lineChartsExportDates(data) {
      return data.map((el, i) => {
        if (i === 0) {
          return el
        } else {
          return el.map((elem, j) => {
            if (j === 0) {
              return dayjs(parseInt(elem)).format('DD-MM-YYYY')
            } else return elem
          })
        }
      })
    },
    exportPBD(title) {
      let dateRange = this.$route.query.update
        ? this.$route.query.update
        : '2023-07-01T00:00:00Z,' + dayjs(new Date()).format('YYYY-MM-DD') + 'T00:00:00Z'
      dateRange = dateRange.replaceAll('-', '/').replaceAll(',', ' - ')
      let typeFi = null
      if (this.typeFilter === 'type')
        typeFi = this.$route.query.typeFil ? this.$route.query.typeFil : t('all_op')
      else if (this.typeFilter === 'downType')
        typeFi = this.$route.query.downTypeFil ? this.$route.query.downTypeFil : t('all_op')
      else if (this.typeFilter === 'language')
        typeFi = this.$route.query.langFil ? this.$route.query.langFil : t('all_op')
      let wordSearch = null
      if (this.typeFilter === 'type')
        wordSearch = this.$route.query.searchType ? this.$route.query.searchType : null
      else if (this.typeFilter === 'downType')
        wordSearch = this.$route.query.searchDownType ? this.$route.query.searchDownType : null
      else if (this.typeFilter === 'language')
        wordSearch = this.$route.query.searchLang ? this.$route.query.searchLang : null

      let data = null
      if (this.chartId === 'evolutiveByType') {
        data = this.lineChartsExportDates(this.parsedDataByType.evolutive)
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'distributionByType') {
        data = this.parsedDataByType.distribution
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'evolutiveByThesaurus') {
        data = this.lineChartsExportDates(this.parsedDataByThesaurus.evolutive)
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'distributionByThesaurus') {
        data = this.parsedDataByThesaurus.distribution
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'access') {
        data = this.lineChartsExportDates(this.parsedDataWebAccess)
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'registers') {
        data = this.lineChartsExportDates(this.parsedDataWebRegisters)
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      }
      // data x export dels rankCharts
      else if (this.chartId === 'item-con') {
        let parsedData = []
        let parsedHeaders = ['Number', 'Type', 'Title', 'Views']
        parsedData.push(parsedHeaders)
        let parsedBody = []
        getItemsViewed(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.query.typeFil ? this.$route.query.typeFil : 'all',
          this.$route.query.searchType ? this.$route.query.searchType : null,
          1,
          100,
          this.$route.params.lang
        ).then(resp => {
          resp.data.values.forEach((el, i) => {
            parsedBody.push(
              ((this.$route.query.itemsPage ? parseInt(this.$route.query.itemsPage) : 1) - 1) *
                this.itemsForPage +
                i +
                1
            )
            parsedBody.push(el.type)
            parsedBody.push(el.label)
            parsedBody.push(el.count)
            parsedData.push(parsedBody)
            parsedBody = []
          })
          data = parsedData
          exportPBDStats(title, dateRange, typeFi, wordSearch, data)
        })
      } else if (this.chartId === 'item-download') {
        let parsedData = []
        let parsedHeaders = ['Number', 'Type', 'Title', 'Downloads']
        parsedData.push(parsedHeaders)
        let parsedBody = []
        getItemsDownloaded(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.query.downTypeFil ? this.$route.query.downTypeFil : 'all',
          this.$route.query.searchDownType ? this.$route.query.searchDownType : null,
          1,
          100,
          this.$route.params.lang
        ).then(resp => {
          resp.data.values.forEach((el, i) => {
            parsedBody.push(
              ((this.$route.query.downPage ? parseInt(this.$route.query.downPage) : 1) - 1) *
                this.itemsForPage +
                i +
                1
            )
            parsedBody.push(el.type)
            parsedBody.push(el.label)
            parsedBody.push(el.count)
            parsedData.push(parsedBody)
            parsedBody = []
          })
          data = parsedData
          exportPBDStats(title, dateRange, typeFi, wordSearch, data)
        })
      } else if (this.chartId === 'words-search') {
        let parsedData = []
        let parsedHeaders = ['Number', 'Word', 'Value']
        parsedData.push(parsedHeaders)
        let parsedBody = []
        getSearchedWords(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.query.langFil ? this.$route.query.langFil : 'ca',
          this.$route.query.searchLang ? this.$route.query.searchLang : null,
          1,
          100
        ).then(resp => {
          resp.data.values.forEach((el, i) => {
            parsedBody.push(
              ((this.$route.query.langPage ? parseInt(this.$route.query.langPage) : 1) - 1) *
                this.itemsForPage +
                i +
                1
            )
            parsedBody.push(el.label)
            parsedBody.push(el.count)
            parsedData.push(parsedBody)
            parsedBody = []
          })
          data = parsedData
          exportPBDStats(title, dateRange, typeFi, wordSearch, data)
        })
      } else if (this.chartId === 'country-use') {
        let parsedData = []
        let parsedHeaders = ['Number', 'Country', 'Value']
        parsedData.push(parsedHeaders)
        let parsedBody = []
        getCountryUsage(
          this.$route.query.update ? this.$route.query.update : 'all',
          this.$route.params.lang,
          1,
          100
        ).then(resp => {
          resp.data.values.forEach((el, i) => {
            parsedBody.push(
              ((this.$route.query.countryPage ? parseInt(this.$route.query.countryPage) : 1) - 1) *
                this.itemsForPage +
                i +
                1
            )
            parsedBody.push(el.label)
            parsedBody.push(el.count)
            parsedData.push(parsedBody)
            parsedBody = []
          })
          data = parsedData
          exportPBDStats(title, dateRange, typeFi, wordSearch, data)
        })
      } else if (this.chartId === 'lang-use') {
        data = this.parsedLanguageUse
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'device-use') {
        data = this.parsedDeviceUse
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      } else if (this.chartId === 'time-use') {
        data = this.parsedDeviceUse
        exportPBDStats(title, dateRange, typeFi, wordSearch, data)
      }
    },
    changeRouteQuery(query) {
      let element = this.$refs['cardchart']
      let header = document.getElementById('header')?.offsetHeight || 0
      let top = element.offsetTop - header - (header !== 0 ? 45 : 10)
      this.$router
        .push({
          name: this.$route.name,
          params: this.$route.params,
          query: query,
        })
        .then(() => {
          window.scrollTo(0, top)
        })
    },
    searchFunc(value, type) {
      let queryParams = { ...this.$route.query }
      if (type === 'type') {
        if (queryParams.searchType !== value) {
          if (value === '') delete queryParams.searchType
          else queryParams.searchType = value
          this.changeRouteQuery(queryParams)
        }
      } else if (type === 'down-type') {
        if (queryParams.searchDownType !== value) {
          if (value === '') delete queryParams.searchDownType
          else queryParams.searchDownType = value
          this.changeRouteQuery(queryParams)
        }
      } else if (type === 'language') {
        if (queryParams.searchLang !== value) {
          if (value === '') delete queryParams.searchLang
          else queryParams.searchLang = value
          this.changeRouteQuery(queryParams)
        }
      }
    },
    tooltipFunction(d, key, self) {
      return statsSdvTooltipFunction(
        d,
        key,
        self,
        this.chartId === 'distributionByType'
          ? this.parsedDataByType.distributionTypeDate
          : this.chartId === 'distributionByThesaurus'
          ? this.parsedDataByThesaurus.distributionThesaurusDate
          : null
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.chart-card
  position: relative
  display: flex
  flex-direction: column
  padding: vw(20px)
  width: 100%
  height: fit-content
  background-color: #fff
  box-shadow: 0 0 3px $bcn-light-grey
  gap: vw(20px)

  .chart-wrap
    .sdv-chart
      >>> .el
        .wrapper
          margin: 0 !important
          width: 100% !important
          height: 100% !important

  .card-header
    display: flex
    justify-content: space-between
    gap: vw(20px)

    .mobile &
      flex-direction: column

  .card-title
    m-font-size(18, 26)
    color: black
    font-weight: 600

    .mobile &
      display: flex
      gap: vw(20px)

      > span
        flex: 1 1 0%

  .card-buttons-wrapper
    display: flex
    flex-wrap: wrap
    gap: vw(10px)

    .mobile &
      flex-wrap: nowrap
      margin-bottom: vw(20px)

  .button-download
    m-icon("download-white-fill", 32, black, false)
    cursor: pointer

  .paginate-wrapper
    display: flex
    justify-content: center
    width: 100%

  .card-body
    background-color: white

    .sdv-chart
      position: relative
      height: vw(300px)

    .no-data
      m-font-size(16, 24)
      padding: vw(20px)
      color: $grey-dark
      text-align: center
      font-weight: 400
      
    .loader-wrap
      position: relative
      width: 100%
      height: 110px
</style>
